import React from 'react';
import PropTypes from 'prop-types';
import keycloak from '../keycloak/keycloak';
import { logUserOut } from '../user/userActions';
import { clearCDNCachedContent } from '../utils/offlineUtils';
import useEffectOnce from "../../hooks/use-effect-once";

const AmpNavigationContainer = ({
    trackLogOut,
}) => {
    useEffectOnce(() => {
        const loadAmpNav = async () => {
            try {
                window.AmpNavigationV2Module.renderAmpNavV2('amp-nav-v2-container', {
                    _keycloak: {
                        ...keycloak,
                        userInfo: keycloak.tokenParsed
                    },
                    appName: 'mCLASS',
                    focus: false,
                    adultsView: false,
                    customLogoutHandler: () => { trackLogOut().then(clearCDNCachedContent()).then(logUserOut()); }
                });
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('Failed to load AmpNavigationV2Module:', error);
            }
        };

        loadAmpNav();
    }, []);

    return (<nav id="amp-nav-v2-container" />);
};

AmpNavigationContainer.propTypes = {
    trackLogOut: PropTypes.func,
};

AmpNavigationContainer.defaultProps = {
    trackLogOut: () => { },
};

export default AmpNavigationContainer;
